var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.preventDefault();_vm.show = !_vm.show}}},[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"absolute z-10 border leading-none mt-0.5 bg-white py-2 rounded shadow-lg",class:{'right-0': _vm.right}},[_vm._t("dropdown")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }